import { Group, Stack, Tabs, Text } from "@mantine/core";
import { IconFileText } from "@tabler/icons-react";
import urls from "../../../../../../urls";
import type { TodoFile } from "../../../../../../utils/backend-types";
import { DownloadLink } from "../../../../../DownloadLink/DownloadLink";

export type UserDocumentsModalProps = {
  msbDocuments: TodoFile[];
  vermarkterDocuments: TodoFile[];
};

function DocumentSection({ documents }: { documents: TodoFile[] }) {
  return (
    <Stack gap="xs">
      {documents.map((document) => (
        <Group align="flex-start" gap="xs" key={document.id} wrap="nowrap">
          <IconFileText size="1.2em" />
          <Stack flex={1} gap={0}>
            <DownloadLink
              filename={document.name}
              url={urls.api.todoDocumentDownload(document.id)}
            >
              {document.name}
            </DownloadLink>
            <Text c="dimmed" size="xs">
              erstellt am {document.creationDatetime}
              {document.createdBy?.name
                ? ` von ${document.createdBy.name}`
                : ""}
            </Text>
          </Stack>
        </Group>
      ))}
    </Stack>
  );
}

function UserDocumentsModal({
  msbDocuments,
  vermarkterDocuments
}: UserDocumentsModalProps) {
  const activeTab =
    msbDocuments.length > 0 ? "msb-documents" : "vermarkter-documents";
  return (
    <Stack>
      <Tabs defaultValue={activeTab}>
        <Tabs.List>
          {msbDocuments.length > 0 && (
            <Tabs.Tab value="msb-documents">Messstellenbetreiber</Tabs.Tab>
          )}
          {vermarkterDocuments.length > 0 && (
            <Tabs.Tab value="vermarkter-documents">Vermarkter</Tabs.Tab>
          )}
        </Tabs.List>

        <Tabs.Panel value="msb-documents">
          <DocumentSection documents={msbDocuments} />
        </Tabs.Panel>
        <Tabs.Panel value="vermarkter-documents">
          <DocumentSection documents={vermarkterDocuments} />
        </Tabs.Panel>
      </Tabs>
    </Stack>
  );
}

export { UserDocumentsModal };
